<template>
	<div class="chat-common-header" v-show="source && Object.keys(source).length > 0">
		<section class="chat-common-header__box">
			<div>
				<h3>{{$$(source,'nickname')}}</h3>
				<span class="text">
					<el-tooltip class="item" effect="dark" :content="getChannle($$(source,'channel'))" placement="top-start">
					      <i class="iconfont" :class="getCnannelIcon($$(source,'channel'))" style="margin-right: 8px;"></i>
					</el-tooltip>
				</span>
				<span class="text">技能组：
					<el-tooltip class="item" effect="dark" :content="$$(source,'skillGroupDesc')" placement="top-start" :disabled="isDisabled($$(source,'skillGroupDesc'))">
					      <span class="desc" :class="{'ishasDot':ishasDot}">{{$$(source,'skillGroupDesc')}}</span>
					</el-tooltip>
				</span>
				<span class="text">品牌：
				<el-tooltip class="item" effect="dark" :content="$$(source,'brandDesc')" placement="top-start" :disabled="isDisabled($$(source,'brandDesc'))">
				      <span class="desc" :class="{'ishasDot':ishasDot}">{{$$(source,'brandDesc')}}</span>
				</el-tooltip>
				</span>
			</div>
			<div>
				<span class="text">会话：{{$$(source,'session_id')}}</span>
				<span class="text" v-show="$$(source,'mobile')">手机：{{$$(source,'mobile')}}</span>
				<span class="text" v-show="$$(source,'browser')">来源：{{$$(source,'browser')}}</span>
			</div>
		</section>
	</div>
</template>

<script>
	import { getCnannelIcon } from '@/utils/imService';
	import {channel} from '../../data.js';
	export default {
		props:{
			source: {
			  default () {
				return {}
			  }
			},
		},
		data(){
			return {
				ishasDot:false,
			}
		},
		methods:{
			getCnannelIcon,
			isDisabled(data){
				if(data && data.length > 24){
					return false
				}
				return !this.ishasDot
			},
			getChannle(id){
				const index = channel.findIndex((el) => el.id == id);
				if(index != -1){
					return channel[index].name
				}
			}
		},
		mounted(){
			const boxes = document.querySelector('.im-service-panel-width');
			const myObserver = new ResizeObserver(entries => {
				for(let entry of entries) {
					const width = Math.floor(entry.contentRect.width);
					if(width < 520) {
						this.ishasDot = true;
					}else{
						this.ishasDot = false;
					}
					
				}
			});
			myObserver.observe(boxes);
		}
	}
</script>

<style lang="scss" scoped>
	.chat-common-header {
		width: 100%;
		height: 55px;
		border-bottom:1px solid #D8D8D8;
		padding: 0px 20px;
		font-size: 12px;
		color: #838A9D;
		display: flex;
		justify-content: space-between;
		align-items: center;
		position: relative;
		&__box {
			width: calc(100% - 100px);
			> div {
				display: flex;
				align-items: center;
				h3 {
					color: #3C4353;
					font-size: 14px;
					font-weight: 600;
					display: inline-block;
					flex-shrink: 0;
				}
				.text {
					margin-left: 8px;
					display: flex;
					align-items: center;
					flex-shrink: 0;
					.iconfont {
						color: #fff;
						width: 16px;
						height: 16px;
						background: #566980;
						display: inline-block;
						border-radius: 50%;
						line-height: 16px;
						text-align: center;
						font-size: 12px;
					}
					
					
				}
				.desc {
					display: inline-block;
					overflow: hidden;
					max-width: 200px;
					text-overflow: ellipsis;
					white-space: nowrap;
					&.ishasDot {
						width: 90px;
					}
				}
				&:nth-of-type(2) {
					margin-top: 5px;
					.text {
						&:nth-of-type(1) {
							margin: 0 ;	
						}
						&:nth-of-type(2) {
							margin: 0 8px;
						}
					}
				}
			}
		}
	}
</style>